import React from 'react';
import { BuilderActionType, BuilderContext } from './state';
import { Image, Video } from '../../Components/Icon';

type Props = {
    url?: string;
    type?: 'IMAGE' | 'VIDEO' | 'FONT';
    onChange: (url: string) => void;
};

function MediaSelector({ url, onChange, type }: Props) {
    const { dispatch } = React.useContext(BuilderContext);

    const Icon = type === 'VIDEO' ? Video : Image;
    let label = 'Choose media';

    if (type === 'VIDEO') {
        label = 'Choose video';
    } else if (type === 'IMAGE') {
        label = 'Choose image';
    }

    const handleClick = () => {
        dispatch({
            type: BuilderActionType.SET_MEDIA_LIBRARY,
            payload: {
                open: 'MEDIA',
                onChange,
                selected: url,
                type,
            },
        });
    };
    if (url && url.length > 0) {
        return (
            <object
                onClick={handleClick}
                tabIndex={0}
                role="button"
                onKeyDown={(e) => e.key === 'Enter' && handleClick()}
                data={url}
                className="h-24 w-full max-w-[148px] rounded-xl border border-slate-200 bg-white object-cover shadow-sm transition hover:border-secondary"
            >
                thumbnail
            </object>
        );
    }
    return (
        <div
            onClick={handleClick}
            tabIndex={0}
            role="button"
            onKeyDown={(e) => e.key === 'Enter' && handleClick()}
            className="flex h-24 w-full max-w-[148px] cursor-pointer flex-col items-center justify-center rounded-xl border border-dashed border-slate-300 bg-slate-50 text-slate-500 transition hover:border-secondary hover:text-slate-700"
        >
            <Icon className="h-5 w-5" />
            <p className="mt-2 text-xs font-medium">{label}</p>
        </div>
    );
}

export default MediaSelector;
